import StyleConstants from '../../../common/StyleConstants';
import ChannelButton from '../../../components/ChannelButton';
import FooterView from '../../../components/FooterView';
import MenuView from '../../../components/MenuView';
import RecommendView from '../../program-detail/view/sub-view/RecommendView';
import ReviewViewV2 from '../../program-detail/view/sub-view/ReviewViewV2';
import DescView from './subView/DescView';
import HelpView from './subView/HelpView';
import PreviewView from './subView/PreviewView';
import ProblemView from './subView/ProblemView';
import ProgramView from './subView/ProgramView';
import ReasonView from './subView/ReasonView';
import TitleView from './subView/TitleView';

export default function LandingView({
  userStatus,
  isOpenMenu,
  onClickOpenMenu,
  onClickCloseMenu,
  onClickGotoHome,
  onClickGotoDetail,
  onClickOpenVideoView,
  onClickOpenImgView,
  onClickOpenReviewView,
  getUserName,
  reviewList,
  totalParticipatedCnt,
  avgImprovementRate,
  reviewCnt,
  isStartReviewScoreAnimation,
}) {
  return (
    <div style={{ display: 'block', maxWidth: `${StyleConstants.MAX_WIDTH}px`, width: '100%' }}>
      <MenuView
        userStatus={userStatus}
        isOpenMenu={isOpenMenu}
        onClickOpenMenu={onClickOpenMenu}
        onClickCloseMenu={onClickCloseMenu}
        onClickGotoHome={onClickGotoHome}
      />
      <TitleView />
      <ProblemView />
      <ReasonView />
      <DescView />
      <ProgramView />
      <PreviewView />
      <ReviewViewV2
        onClickOpenVideoView={onClickOpenVideoView}
        onClickOpenImgView={onClickOpenImgView}
        onClickOpenReviewView={onClickOpenReviewView}
        getUserName={getUserName}
        reviewList={reviewList}
        totalParticipatedCnt={totalParticipatedCnt}
        avgImprovementRate={avgImprovementRate}
        reviewCnt={reviewCnt}
        isStartReviewScoreAnimation={isStartReviewScoreAnimation}
      />
      <HelpView />
      <RecommendView onClick={onClickGotoDetail} />
      <FooterView />
      {!isOpenMenu && <ChannelButton />}
    </div>
  );
}
